import { render } from "./CreateAssurance.vue?vue&type=template&id=57ef9caa&scoped=true"
import script from "./CreateAssurance.vue?vue&type=script&lang=js"
export * from "./CreateAssurance.vue?vue&type=script&lang=js"

import "./CreateAssurance.vue?vue&type=style&index=0&id=57ef9caa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ef9caa"]])

export default __exports__